import Box from "@mui/material/Box";
import { makeStyles } from "@mui/styles";
import { useLocation } from "react-router-dom";
import EnvInfoTopBar from "../components/EnvInfoTopBar/EnvInfoTopBar";
import SupportModalComponent from "../components/SupportModalComponent/SupportModalComponent";
import { Brand } from "../services/Types";
import { useAuth } from "react-oidc-context";
 
const useStyles = makeStyles({
  main: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center", 
    alignContent: "center",
    marginBottom: "10px"
  },
});
 
function SupportModalPage({ brand, credentialId }: { brand?: Brand, credentialId : string }) {
  const classes = useStyles();
  const auth = useAuth();
  const search = useLocation().search;
  const searchParam = new URLSearchParams(search)  
  
  const originClient = searchParam.get("origin_client");  
  const access_token = auth.user?.access_token;
  const id_token = auth.user?.id_token;
    
  return (
    <>
      <Box className={classes.main}>
        {
          credentialId &&
          <SupportModalComponent {...{
            credentialId,
            originClient,
            access_token,     
            id_token,       
            brand
          }} brand={brand} />
        }
      </Box>
    </>
  );
}
 
export default SupportModalPage;
 